import React, { useEffect, useState } from 'react';
import { Container, Table, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem('cart')) || [];
    setCartItems(storedCart);
  }, []);

  const handleQuantityChange = (index, delta) => {
    const updatedCart = [...cartItems];
    updatedCart[index].quantity += delta;

    if (updatedCart[index].quantity <= 0) {
      updatedCart.splice(index, 1);
    }

    setCartItems(updatedCart);
    localStorage.setItem('cart', JSON.stringify(updatedCart));
  };

  const handleCheckout = () => {
    alert('Checkout successful!');
    localStorage.removeItem('cart');
    setCartItems([]);
  };

  const totalPrice = cartItems.reduce(
    (sum, item) => sum + item.price * item.quantity,
    0
  );

  return (
    <Container className="my-5">
      <h2 className="mb-4">🛒 Your Cart</h2>
      {cartItems.length === 0 ? (
        <div className="text-center mt-4">
          <p className="lead">Your cart is empty.</p>
          <Button variant="primary" onClick={() => navigate('/personal')}>
            Start Shopping
          </Button>
        </div>
      ) : (
        <>
          <Table bordered hover responsive>
            <thead className="table-dark">
              <tr>
                <th>Image</th>
                <th>Product</th>
                <th>Price (₹)</th>
                <th>Quantity</th>
                <th>Subtotal (₹)</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {cartItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <img
                      src={item.image}
                      alt={item.name}
                      width="80"
                      height="80"
                      style={{ objectFit: 'contain', borderRadius: '8px' }}
                    />
                  </td>
                  <td>{item.name}</td>
                  <td>{item.price}</td>
                  <td>{item.quantity}</td>
                  <td>{item.price * item.quantity}</td>
                  <td>
                    <Button
                      variant="success"
                      size="sm"
                      onClick={() => handleQuantityChange(index, 1)}
                    >
                      +
                    </Button>{' '}
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleQuantityChange(index, -1)}
                    >
                      -
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between align-items-center mt-4">
            <h4>Total: ₹{totalPrice}</h4>
            <div>
              <Button variant="success" onClick={handleCheckout} className="me-2">
                Checkout
              </Button>
              <Button variant="secondary" onClick={() => navigate('/personal')}>
                Continue Shopping
              </Button>
            </div>
          </div>
        </>
      )}
    </Container>
  );
};

export default Cart;
